import PropTypes from 'prop-types';
import React from 'react';
import { FaAmazon, FaMedium, FaPatreon, FaPodcast, FaYoutube } from 'react-icons/fa';
import ReactTooltip from 'react-tooltip';

import Helmet from '../components/Helmet';
import NewsForm from '../components/NewsForm';
import { calculateNote } from '../helpers';

const WritePage = ({ notes, write }) => (
  <main className="main-content" itemScope itemType="http://schema.org/Blog">
    <ReactTooltip effect="solid" />
    <Helmet
      description={`Parker Klein's thoughts on ${write.name}`}
      title={`${write.name} by Parker Klein`}
    />
    <div className="item column">
      <img
        className="write-photo"
        alt={`${write.name} by Parker Klein`}
        itemProp="image"
        width={268}
        src={write.photo}
      />
      <h2 className="title" id="write-title" itemProp="name">
        {write.name}
      </h2>
      <p className="time" itemProp="timeRequired">
        {write.time} min read
      </p>
      <p className="date" itemProp="dateCreated">
        {write.date}
      </p>
      <div className="row">
        {write.twosLink && (
          <a
            aria-label={`Read ${write.name} by Parker Klein on Twos`}
            className="icon-link twos"
            data-tip={`${write.name} on Twos`}
            href={write.twosLink}
            itemProp="url"
            rel="noopener noreferrer"
            target="_blank"
            title={`Read ${write.name} by Parker Klein on Twos`}
          >
            <img
              alt="Twos: days, lists, & things"
              src="https://twos.s3.amazonaws.com/twos-thread-background-transparent-300.png"
              height="28px"
              width="20px"
            />
          </a>
        )}
        {write.youtubeLink && (
          <a
            aria-label={`Watch Parker Klein's Notes on ${write.name} by ${write.author} on YouTube`}
            className="icon-link youtube"
            data-tip={`${write.name} on YouTube`}
            href={write.youtubeLink}
            itemProp="url"
            rel="noopener noreferrer"
            target="_blank"
            title={`Watch Parker Klein's Notes on ${write.name} by ${write.author} on YouTube`}
          >
            <FaYoutube />
          </a>
        )}
        {write.patreonLink && (
          <a
            aria-label={`Support Parker Klein's notes on ${write.name} by ${write.author} on Patreon`}
            className="icon-link patreon"
            data-tip={`${write.name} on Patreon`}
            href={write.patreonLink}
            itemProp="url"
            rel="noopener noreferrer"
            target="_blank"
            title={`Support Parker Klein's notes on ${write.name} by ${write.author} on Patreon`}
          >
            <FaPatreon />
          </a>
        )}
        {write.link && (
          <a
            aria-label={`Buy ${write.name} by ${write.author} on Amazon`}
            className="icon-link amazon"
            data-tip={`Buy ${write.name} on Amazon`}
            href={write.link}
            itemProp="url"
            rel="noopener noreferrer"
            target="_blank"
            title={`Buy ${write.name} by ${write.author} on Amazon`}
          >
            <FaAmazon />
          </a>
        )}
        {write.podcastLink && (
          <a
            aria-label={`Listen to Parker Klein's Notes podcast on ${write.name} by ${write.author}`}
            className="icon-link podcast"
            data-tip={`Listen to ${write.name}`}
            href={write.podcastLink}
            itemProp="url"
            rel="noopener noreferrer"
            target="_blank"
            title={`Listen to Parker Klein's Notes podcast on ${write.name} by ${write.author}`}
          >
            <FaPodcast />
          </a>
        )}
        {write.mediumLink && (
          <a
            aria-label={`Read Parker Klein's notes on ${write.name} by ${write.author} on Medium`}
            className="icon-link medium"
            data-tip={`Read ${write.name} on Medium`}
            href={write.mediumLink}
            itemProp="url"
            rel="noopener noreferrer"
            target="_blank"
            title={`Read Parker Klein's notes on ${write.name} by ${write.author} on Medium`}
          >
            <FaMedium />
          </a>
        )}
      </div>
      <ul aria-labelledby="write-title">
        {notes.map((note, i) => <li key={note + i}>{calculateNote(note)}</li>)}
      </ul>
      <NewsForm />
    </div>
  </main>
);

WritePage.propTypes = {
  notes: PropTypes.array.isRequired,
  write: PropTypes.object.isRequired
};

export default WritePage;
